export enum ECalendarChangeMode {
	DIET = 'diet',
	ADDRESS = 'address',
	DAYS = 'days',
	DAYS_TO = 'daysTo',
	DAYS_CANCEL = 'daysCancel',
}

export enum ECalendarFilterValue {
	ALL = 'all',
}

export enum EEmployeePaymentType {
	FREE = 'free',
	PAID = 'paid',
	PLACED = 'placed',
	CART = 'cart',
	REFUND_POINTS = 'refund_points',
	IGNORE_POINTS = 'ignore_points',
}

export const EmployeePaymentTypesMap: Partial<Record<EEmployeePaymentType, string>> = {
	[EEmployeePaymentType.FREE]: 'Za darmo',
	[EEmployeePaymentType.PAID]: 'Opłacone przez klienta',
	[EEmployeePaymentType.CART]: 'Do opłacenia przez klienta',
	[EEmployeePaymentType.REFUND_POINTS]: 'Zwróć środki',
	[EEmployeePaymentType.IGNORE_POINTS]: 'Nie zwracaj środków',
}

export const EmployeePaymentTypesDescriptionMap: Partial<Record<EEmployeePaymentType, string>> = {
	[EEmployeePaymentType.FREE]: 'Zamówienie nie jest obciążane – klient nie płaci (np. rekompensata, promocja).',
	[EEmployeePaymentType.PAID]: 'Klient już opłacił – zamówienie uznane za opłacone, bez dalszej windykacji.',
	[EEmployeePaymentType.CART]: 'Zamówienie w koszyku – do opłacenia przez klienta (oczekuje na płatność).',
	[EEmployeePaymentType.PLACED]: 'Zamówienie w koszyku – do opłacenia przez klienta (oczekuje na płatność).',
	[EEmployeePaymentType.REFUND_POINTS]:
		'Zwrot rozliczany punktami – przyznaj klientowi punkty zamiast zwrotu gotówki.',
	[EEmployeePaymentType.IGNORE_POINTS]:
		'Punkty nie są naliczane za tę operację – zamówienie/zwrot bez wpływu na program punktowy.',
}

export const employeePaymentTypes: { value: EEmployeePaymentType; label: string }[] = Object.entries(
	EmployeePaymentTypesMap,
).map(([value, label]) => ({
	value: value as EEmployeePaymentType,
	label,
}))

export const addExtraMealPaymentTypeOptions: { value: EEmployeePaymentType; label: string }[] = [
	{ label: EmployeePaymentTypesMap[EEmployeePaymentType.FREE] ?? '', value: EEmployeePaymentType.FREE },
	{ label: EmployeePaymentTypesMap[EEmployeePaymentType.CART] ?? '', value: EEmployeePaymentType.PLACED },
	{ label: EmployeePaymentTypesMap[EEmployeePaymentType.PAID] ?? '', value: EEmployeePaymentType.PAID },
	{
		label: EmployeePaymentTypesMap[EEmployeePaymentType.REFUND_POINTS] ?? '',
		value: EEmployeePaymentType.REFUND_POINTS,
	},
	{
		label: EmployeePaymentTypesMap[EEmployeePaymentType.IGNORE_POINTS] ?? '',
		value: EEmployeePaymentType.IGNORE_POINTS,
	},
]

export const numberOfMealsTemplate = {
	breakfast: {
		value: 1,
		label: MealTypeMap[EMealType.BREAKFAST],
	},
	second_breakfast: {
		value: 1,
		label: MealTypeMap[EMealType.SECOND_BREAKFAST],
	},
	lunch: {
		value: 1,
		label: MealTypeMap[EMealType.LUNCH],
	},
	afternoon_snack: {
		value: 1,
		label: MealTypeMap[EMealType.AFTERNOON_SNACK],
	},
	dinner: {
		value: 1,
		label: MealTypeMap[EMealType.DINNER],
	},
}

export enum EOrderDayStatus {
	UPCOMING = 'upcoming',
	PROCESSING = 'processing',
	DELIVERED = 'delivered',
	CANCELED = 'canceled',
}

export const OrderDayStatusMap: { [key in EOrderDayStatus]: string } = {
	[EOrderDayStatus.UPCOMING]: 'Nadchodzący',
	[EOrderDayStatus.PROCESSING]: 'Przetwarzany',
	[EOrderDayStatus.DELIVERED]: 'Dostarczony',
	[EOrderDayStatus.CANCELED]: 'Anulowany',
}

export const orderDayStatuses = generateSelectOptions(EOrderDayStatus, OrderDayStatusMap)
